<template>
  <div>
    <!-- <file-up-load
      :applyType="$route.params.applyType"
      :editInfo="params"
    ></file-up-load> -->
     <file-up-load :editInfo="params" :applyType="$route.query.applyType" v-if="news=='ai'" :news="news"></file-up-load>
    <file-up-load1 :editInfo="params" :applyType="$route.query.applyType" v-else :news="news"></file-up-load1>
  </div>
</template>

<script>
// import fileUpLoad from "../../components/szMicroClassFileupload/index";
import fileUpLoad from "../../components/szMicroClassFileupload1/index2.vue";
import fileUpLoad1 from "../../components/szMicroClassFileupload/index2.vue";
import { getAction } from "@/api/index";
export default {
  name: "",
  components: {
    fileUpLoad,
    fileUpLoad1
  },
  props: {},
  data() {
    return {
        params: null,
        id: "",
        news:'add',
    //  params: this.$route.params.id ? this.$route.params : null
    };
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {
       if(this.$route.query.new){
        this.news=this.$route.query.new;
       }
        if(this.$route.query.id){
          this.id=this.$route.query.id;
          window.sessionStorage.setItem(`step${this.$store.state.user.id}`,this.id);
          this.getQueryId();
        }else if(window.sessionStorage.getItem(`step${this.$store.state.user.id}`)){
          this.id=window.sessionStorage.getItem(`step${this.$store.state.user.id}`);
          this.getQueryId();
        }else{
          this.id='';
          this.params=null;
        }
  },
  methods: {
      getQueryId() {
      let data = {
        id: this.id,
      };
      getAction("/lx/lxApply/queryById", data).then(res => {
        if (res.code === 200) {
          const result = res.result || {};
          // 预览/审核查看进入：标记只读，子组件据此禁用全部字段
          if (
            this.news === "preview" ||
            this.news === "audit" ||
            this.$route.query.new === "preview" ||
            this.$route.query.new === "audit"
          ) {
            result.type = "preview";
          }
          this.params = result;
        }
      });
    }
  },
};
</script>

<style scoped >
::-webkit-scrollbar {
  width: initial;
}

::-webkit-scrollbar-thumb {
  background-color: initial;
}

::-webkit-scrollbar-track {
  background-color: initial;
}

/* Firefox */
* {
  scrollbar-width: auto; /* 恢复默认宽度 */
  scrollbar-color: initial; /* 恢复默认颜色 */
}
</style>
